@if (loading) {
  <div class="loader"></div>
}
@if (!loading) {
  <div>
    <div class="header">
      <div class="breadcrump">
        <ul>
          <li>{{'Home' | translate}}</li>
        </ul>
      </div>
      <div class="page-tittle">
        <h1>Production <span>Logik</span></h1>
      </div>
    </div>
    <div class="L-12 M-12 S-12 columns">
      <div class="menubar centered">
        @for (page of pages; track page) {
          @if (page.secure_module == 0 || _gS.validateAcces({id:page.secure_module, type:'read'}, page)) {
            <div class="menu-button" (click)="loading = true" [routerLink]="page.link">
              <div class="label">{{'View' | translate}}</div>
              {{page.name | translate}}
            </div>
          }
        }
      </div>
    </div>
  </div>
}

